import React from 'react';
import config from 'config';
import WebLink from '../../../components/@common/WebLink';
import { lnfBlue } from '../../../styles/style-constants';
import { translate } from '../../../translations/translator';
import { FONT_GSS_FUTURA } from 'themes/default';
import { makeStyles } from '@mui/styles';
const translateCopyright = (key, options?) => translate('copyright', key, options);

type Props = {
  productTitle: string;
};

const dialogHeight = window.innerHeight > 600 ? 400 : window.innerHeight - 200;

const useStyles = makeStyles(() => ({
  anchor: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: lnfBlue,
    ':hover': {
      textDecoration: 'none'
    }
  },
  modalText: {
    textAlign: 'left',
    userSelect: 'none',
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '16px',
    fontWeight: 300,
    maxHeight: dialogHeight,
    overflowY: 'auto'
  }
}));

export const TrialUserCopyright = (props: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.modalText}>
      <p>
        {translateCopyright('freeTrial1', {
          title: props.productTitle
        })}
      </p>
      <p>
        {translateCopyright('freeTrial2')}
        <WebLink
          className={classes.anchor}
          to={`mailto:${config.copyrightEmail}`}
          name="legal@LWTears.com"
        />
        {translateCopyright('phone')}
      </p>
    </div>
  );
};

export const LicensedUserCopyright = (props: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.modalText}>
      <p>
        {translateCopyright('fullLicense1', {
          title: props.productTitle
        })}
      </p>
      <p>
        {translateCopyright('fullLicense2')}
        <WebLink
          className={classes.anchor}
          to={`mailto:${config.copyrightEmail}`}
          name="legal@LWTears.com"
        />
        {translateCopyright('phone')}
      </p>
    </div>
  );
};
